import { datesToISO, parseBoolean } from "@";

// Fill form with project attributes
export function fillForm(data) {
  if (!data?.orderLines) return {};

  const orderLines = data?.orderLines.map((item) => ({
    id: item.id,
    quantity: item.quantity,
    projectName: item.projectName,
    unitAmount: item.totalAmount / item.quantity,
    totalAmount: item.totalAmount,
    orderLineType: item.orderLineType,
  }));

  return {
    orderLines,
    bankTransferReceiptUrl: data.bankTransferReceiptUrl,
  };
}

// search values payload for donations
export const searchValuesPayload = ({
  id,
  page,
  isPaid,
  toDate,
  perSize,
  toAmount,
  clientId,
  fromDate,
  fromAmount,
  phoneNumber,
  paymentType,
  orderStatus,
  orderType,
}) => ({
  clientId,
  page: page,
  pageSize: perSize,
  id: parseInt(id) || null,
  toDate: datesToISO(toDate),
  isPaid: parseBoolean(isPaid),
  fromDate: datesToISO(fromDate),
  phoneNumber: phoneNumber || null,
  paymentType: parseInt(paymentType),
  orderStatus: parseInt(orderStatus),
  orderType: parseInt(orderType),
  toAmount: parseInt(toAmount) || null,
  fromAmount: parseInt(fromAmount) || null,
});
